import EmployeeMappingActionTypes from "../constants/employeeMapping-actionTypes";

const initialState = { 
  employeeMappingData:[],
  employeeMappingRoles:[],
  employeeMappingAccounts:[],
  employeeMappingSites:[]

}


const EmployeeMappingReducer = (state = initialState, action) => {
    switch (action.type) {
      case EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_DATA:
      case EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ROLES:
      case EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ACCOUNTS:
      case EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_SITES:

         return { ...state };
      case EmployeeMappingActionTypes.EMPLOYEEMAPPING_DATA:
         return { ...state, employeeMappingData: action.payload };
      case EmployeeMappingActionTypes.EMPLOYEEMAPPING_ROLES:
         return { ...state, employeeMappingRoles: action.payload };
      case EmployeeMappingActionTypes.EMPLOYEEMAPPING_ACCOUNTS:
         return { ...state, employeeMappingAccounts: action.payload };
      case EmployeeMappingActionTypes.EMPLOYEEMAPPING_SITES:
         return { ...state, employeeMappingSites: action.payload };
      default:
         return state;
    }
  };
export default EmployeeMappingReducer;